import Modal from 'react-modal';
import React from 'react';
import PropTypes from 'prop-types';
import cookiesFactory from '../../../base/cookies-factory';
import { howItWorksEstimatesModalLoaded } from '../../estimateBuilder/analytics/analyticsFunctions';

class EstimateModal extends React.Component {
  componentDidMount() {
    document.addEventListener('createEstimate', (e) => {
      howItWorksEstimatesModalLoaded();

      if (cookiesFactory.isInternalUser()) {
        window.location = '/estimatebuilder/new';
      } else {
        this.props.openEstimateModal(e);
      }
    });
  }

  styles =
    {
      estimateModalContent: {
        padding: 20,
        marginLeft: 'auto',
        marginRight: 'auto',
        width: 1025,
      },

      estimateModalClose: {
        float: 'right',
        textDecoration: 'none',
        cursor: 'pointer',
      },

      estimateModalTitleAndSteps: {
        paddingTop: 50,
        paddingBottom: 50,
      },

      estimateModalTitle: {
        height: 38,
        width: 300,
        color: '#333333',
        fontFamily: 'Helvetica Neue, Helvetica, Arial, sans-serif',
        fontSize: 32,
        fontWeight: 300,
        lineHeight: 39,
        textAlign: 'center',
        marginLeft: 'auto',
        marginRight: 'auto',
      },

      estimateModalLine: {
        boxSizing: 'border-box',
        height: '0.2%',
        width: '70%',
        border: '1px solid #CCCCCC',
        marginLeft: 'auto',
        marginRight: 'auto',
        marginTop: 30,
        marginBottom: 30,
      },

      estimateModalContentStepContainer: {
        display: 'block',
        marginLeft: 'auto',
        marginRight: 'auto',
        textAlign: 'center',
        paddingBottom: 50,
      },

      estimateModalContentStep: {
        display: 'inline-block',
        marginLeft: 'auto',
        marginRight: 'auto',
        padding: 10,
      },

      estimateModalContentStepImage: {
        display: 'block',
        marginLeft: 'auto',
        marginRight: 'auto',
        verticalAlign: 'top',
        height: 62,
      },

      estimateModalContentStepName: {
        color: '#405FAF',
        fontFamily: 'Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: 18,
        textAlign: 'center',
        paddingTop: 20,
        margin: 5,
      },

      estimateModalContentStepDescription: {
        textAlign: 'center',
        fontFamily: 'Helvetica Neue, Helvetica, Arial, sans-serif',
        fontSize: 14,
        margin: 0,
      },

      estimateModalBtnGetStarted: {
        display: 'block',
        height: 42,
        width: 263,
        borderRadius: 4,
        backgroundColor: '#405FAF',
        color: 'white',
        fontFamily: 'Helvetica Neue, Helvetica, Arial, sans-serif',
        fontSize: 16,
        fontWeight: 500,
        lineHeight: 19,
        textAlign: 'center',
        textDecoration: 'none',
        cursor: 'pointer',
        marginLeft: 'auto',
        marginRight: 'auto',
        paddingTop: 10,
      },
    }

  render() {
    return (
      <div>
        <Modal
          isOpen={this.props.isOpen}
          ariaHideApp={false}
          contentLabel="Modal"
          onRequestClose={this.props.onCloseEstimateModal}
          closeTimeoutMS={200}
          className="gcc-modal"
          overlayClassName="gcc-modal-overlay"
          style={{
            content: {
              height: 500,
              width: 1025,
            },
          }}
        >
          <div className="estimateModalContent" style={this.styles.estimateModalContent}>
            <div id="estimateModalClose" className="estimateModalClose" style={this.styles.estimateModalClose} onClick={this.props.onCloseEstimateModal} role="button" tabIndex={0}>
              <img src="/Content/Images/Blinds.com/icon_close_x.svg" alt="" />
            </div>
            <div className="estimateModalTitleAndSteps" style={this.styles.estimateModalTitleAndSteps}>
              <div className="estimateModalTitle" style={this.styles.estimateModalTitle}><p>How it Works</p></div>
              <div className="estimateModalLine" style={this.styles.estimateModalLine} />
              <div className="estimateModalContentStepContainer" style={this.styles.estimateModalContentStepContainer}>
                <div className="estimateModalContentStep" style={this.styles.estimateModalContentStep}>
                  <img className="estimateModalContentStepImage" style={this.styles.estimateModalContentStepImage} src="/Content/Images/Blinds.com/Icon_Window.svg" alt="" />
                  <p className="estimateModalContentStepName" style={this.styles.estimateModalContentStepName}>Shop</p>
                  <p className="estimateModalContentStepDescription" style={this.styles.estimateModalContentStepDescription}>Browse our selection to find just
                    <br /> what you&#39;re looking for.
                  </p>
                </div>
                <div className="estimateModalContentStep" style={this.styles.estimateModalContentStep}>
                  <img className="estimateModalContentStepImage" style={this.styles.estimateModalContentStepImage} src="/Content/Images/Blinds.com/Icon_MeasureTape.svg" alt="" />
                  <p className="estimateModalContentStepName" style={this.styles.estimateModalContentStepName}>Measure</p>
                  <p className="estimateModalContentStepDescription" style={this.styles.estimateModalContentStepDescription}>DIY measure your windows or
                    <br />book a pro-measure appointment.
                  </p>
                </div>
                <div className="estimateModalContentStep" style={this.styles.estimateModalContentStep}>
                  <img className="estimateModalContentStepImage" style={this.styles.estimateModalContentStepImage} src="/Content/Images/Blinds.com/Icon_Truck.svg" alt="" />
                  <p className="estimateModalContentStepName" style={this.styles.estimateModalContentStepName}>Order</p>
                  <p className="estimateModalContentStepDescription" style={this.styles.estimateModalContentStepDescription}>Customize and order the perfect fit
                    <br />for your window coverings.
                  </p>
                </div>
                <div className="estimateModalContentStep" style={this.styles.estimateModalContentStep}>
                  <img className="estimateModalContentStepImage" style={this.styles.estimateModalContentStepImage} src="/Content/Images/Blinds.com/Icon_Wrench.svg" alt="" />
                  <p className="estimateModalContentStepName" style={this.styles.estimateModalContentStepName}>Install</p>
                  <p className="estimateModalContentStepDescription" style={this.styles.estimateModalContentStepDescription}>DIY install or book an installation
                    <br />appointment once products arrive.
                  </p>
                </div>
              </div>
              <div>
                <a className="estimateModalBtnGetStarted" style={this.styles.estimateModalBtnGetStarted} onClick={this.props.onCloseEstimateModal} href="/estimatebuilder/new">
                  <p>Get Started</p>
                </a>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

EstimateModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onCloseEstimateModal: PropTypes.func.isRequired,
  openEstimateModal: PropTypes.func.isRequired,
};

export default EstimateModal;
